import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/dashboard/[id]/dearest/sessions/page";

export const Route = createFileRoute(
  "/clients/$clientId/dashboard/dearest/sessions",
)({
  component: Page,
});
